import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 환율 히스토리 목록 조회
 * @param {Object} [params] 요청 데이터
 * @param {string} [params.nationCode] 국가
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.sfms.exchangeRate.default, { params });
}

/**
 * 환율 등록
 * @param {Object} data 요청 데이터
 * @param {string} data.exchangeYm 월
 * @param {string} data.nationCode 국가
 * @param {number} data.rate 환율 가격
 * @return {Object} 응답 데이터
 */
async function requestInsert(data) {
  return api.post(API_URL.sfms.exchangeRate.default, data);
}

/**
 * 월 환율 정보 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.exchangeYm 월
 * @return {Object} 응답 데이터
 */
async function requestInform(params) {
  return api.get(API_URL.sfms.exchangeRate.inform, { params });
}

export { requestList, requestInsert, requestInform };
